import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	value: 0,
};

const qCardSlice = createSlice({
	name: "qCardCompletedCourses",
	initialState: initialState,
	reducers: {
		updateQCard(state, action) {
			// console.log("update qCardCompletedCourses");
			// console.log(action);

			state.value = action.payload.value;
		},
	},
});

export const qCardCompletedCoursesActions = qCardSlice.actions;

export default qCardSlice;
